import { createFileRoute } from '@tanstack/react-router';
import { OffboardingPage } from '@/features/team/pages/offboarding-page';

export const Route = createFileRoute('/_app/team/$id/offboarding')({ component: OffboardingPage });
